import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import {
  WIDGET_REGISTRY,
  DEFAULT_WIDGET_REGISTRY,
} from 'web-reader-lib';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    {
      provide: WIDGET_REGISTRY,
      useValue: DEFAULT_WIDGET_REGISTRY,
    },
  ],
};
